/**
 * @module utils
 */
import * as authUtils from './authUtils';

import * as backendURL from './backendURL';

export default {
  ...authUtils,
  ...backendURL,
};
